export default __webpack_public_path__ + "static/shutterstock_12-083e727f3e7c87777de6fdadcaed0613.jpg";